import { EventViewData } from 'components/eventView/pages/eventData';

export const ItaliaTourBolognaEvent: EventViewData = {
    eventId: 'italia-bologna',
    mapId: '1a96713c-dafa-45e5-8b01-abb3e10a8f00',
    guideId: '2239a200-2c5a-4658-837e-2ae3236d91cc',
    eventInfo: {
        externalLinkPosition: 'top',
        externalLinkStyle: 'small',
        externalLinkButtonBackground: '#000',
        externalLinkButtonTextColor: '#fff'
    }
};
